import { BREAKPOINT_MEDIUM, BREAKPOINT_PHONE, BREAKPOINT_TABLET, BREAKPOINT_LARGE, BREAKPOINT_SMALL_PHONE, type IBreakPoint } from "@/constants/breakpoints";
import { useWindowSize } from "@vueuse/core";

export type UseResponsive = {
	isSmallPhone: ComputedRef<boolean>;
	isPhone: ComputedRef<boolean>;
	isTablet: ComputedRef<boolean>;
	isDesktop: ComputedRef<boolean>;
	isSmall: ComputedRef<boolean>;
	isMedium: ComputedRef<boolean>;
	isLarge: ComputedRef<boolean>;
}

export const useResponsive = (): UseResponsive => {
  const win = useWindowSize();

  const matchBreakpoint = (x: number, y: number, point: IBreakPoint) =>{
    const xMatches = point.x > 0 ? x < point.x : true;
    const yMatches = point.y > 0 ? y < point.y : true;
    return xMatches && yMatches;
  }

  const isSmallPhone = computed(() => win.width.value <= BREAKPOINT_SMALL_PHONE.x);

  const isPhone = computed(() => {
    return matchBreakpoint(win.width.value, win.height.value, BREAKPOINT_PHONE);
  });

  const isTablet = computed(() => {
    return !isPhone.value && matchBreakpoint(win.width.value, win.height.value, BREAKPOINT_TABLET);
  });

  const isDesktop = computed(() => {
    return !isTablet.value && !isPhone.value;
  });

  const isSmall = computed(() => win.width.value <= BREAKPOINT_TABLET.x);

  const isMedium = computed(() => win.width.value <= BREAKPOINT_MEDIUM.x);

  const isLarge = computed(() => win.width.value <= BREAKPOINT_LARGE.x);

  return {
	isSmallPhone,
    isPhone,
    isTablet,
    isDesktop,
    isSmall,
    isMedium,
    isLarge
  }
}
